import React from "react";

const AudioContext = React.createContext({
  audioEnabled: true,
  toggleAudio: () => {},
});

export default AudioContext;
